import React from 'react';
import moment from "moment";
import { Modal, Icon, Form, Select, Tag, DatePicker, Input, Tabs, Button } from 'antd';
import global from "../../../common/utility/global";
import { FORMAT_NUMBER, FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';
import DetalleResultList from './FondoFijoDetalleModal/DetalleResultList';

const InputGroup = Input.Group;
const { Option } = Select;
const { Search } = Input;
const { TabPane } = Tabs;

class FondoFijoDetalleModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                
                const form = {
                    id: values.id,
                    listaFondoFijoDetalle: this.fetchDetalle(values)
                };

                this.props.onSave(form, this.props.form);
            }
        });
    };


    fetchDetalle = (values) => {
        
        var result = [];

        if (
            values.arrFechaEntrega === undefined
            // values.arrEmpleado === undefined,
            // values.arrRegistroContable === undefined,
            // values.arrCuentaContable === undefined
        )
            return result;

        var keys = [];
        var obj = Object.assign({},
            values.arrFechaEntrega,
            values.arrEmpleado,
            values.arrRegistroContable,
            values.arrCuentaContable,
            values.arrMoneda,
            values.arrMonto,
            values.arrDescripcion,
        );

        for (var [key] of Object.entries(obj)) {
            keys.push(key);
        }
        keys.forEach((key) => {
            result.push({
                fechaEntrega: values.arrFechaEntrega[key]._i,
                idEmpleado: values.arrEmpleado[key].key,
                registroContable: values.arrRegistroContable[key],
                idPlanCuenta: values.arrCuentaContable[key].key,
                idMoneda: values.arrMoneda[key].key,
                monto: parseFloat(values.arrMonto[key]),
                descripcion: values.arrDescripcion[key]
            });
        });

        return result;
    };

    handleSearchAutocompleteEmpleado = async (value) => {
        const result = this.props.formValuesDetalle.empleados.filter(item => {
            return global.formatSearch(`${item.nombre} - ${item.tipoDocumento}`).match(global.formatSearch(value));
        }).slice(0, 75);
        this.props.form.setFieldsValue({ empleados: result });
    };

    handleChangeAutocompleteEmpleado = async (a, element) => {
        this.props.form.setFieldsValue({
            documentoEmpleado: element.props.data.numeroDocumento,
            idEmpleado: element.props.data.idEmpleado
        }, () => {
            this.props.onChange("idEmpleado", element.props.data.idEntidad, this.props.form)
        });
    };

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        // var arrayTemp = [];
        // var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        // for (var i = 0; i < this.props.formValues.listaFondoFijoDetalle.length; i++) {
        //     var item = this.props.formValues.listaFondoFijoDetalle[i];
        //     var existItem = arrDetalle.filter(m => { return m.identifier === item.idProducto })

        //     var d = {
        //         registroContable: item.registroContable
        //     };

        //     arrayTemp.push(d);
        // }

        // getFieldDecorator('arrDetalle', { initialValue: arrayTemp });
        // getFieldDecorator("id", { initialValue: this.props.formValuesDetalle.id });

        // getFieldDecorator("empleados", {
        //     initialValue: this.props.formValuesDetalle.empleados.filter((m) => {
        //         return m.id === this.props.formValuesDetalle.idEmpleado;
        //     }),
        // });
        getFieldDecorator('id', { initialValue: this.props.formValues.id });

        return (
            <Modal
                title={"Detalle Fondo Fijo"}
                visible={this.props.visible}
                onCancel={(properties) => {
                    if (
                        !properties.target.className.toString().match("ant-modal-wrap") ||
                        properties.type === "keydown"
                    )
                        this.handleCancel();
                }}
                style={{ top: 30 }}
                width="1250px"
                footer={[
                    <Button key="cancel" onClick={this.handleCancel}>
                        Cancelar
                    </Button>,
                    <Button key="ok" type="primary"
                        loading={this.props.saveLoading}
                        onClick={this.handleOk}
                    >
                        Guardar
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <DetalleResultList
                                form={this.props.form}
                                source={this.props.formValues.listaFondoFijoDetalle}
                                cuentasContable={this.props.formValues.cuentasContable}
                                empleados={this.props.formValues.empleados}
                                monedas={this.props.formValues.monedas}
                                onAgregarDetalle={this.props.onAgregarDetalle}
                                onDeleteActive={this.props.onDeleteActive}
                                onEliminar={this.props.onEliminarDetalle}
                                onGetFieldDecorator={getFieldDecorator}
                                onSetFieldsValue={setFieldsValue}
                                onGetFieldValue={getFieldValue}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FondoFijoDetalleModal);